import { Image as ImageIcon } from "lucide-react";

export default function PlaceholderImage({
  label,
  sublabel,
  icon: Icon = ImageIcon,
  className = "",
  testId,
  dark = false,
}) {
  return (
    <div
      data-testid={testId}
      className={`flex flex-col items-center justify-center gap-3 text-center px-6 border border-dashed ${
        dark ? "border-white/20 bg-white/[0.03]" : "border-black/20 bg-white"
      } ${className}`}
    >
      <Icon size={26} className={dark ? "text-zinc-500" : "text-zinc-400"} />
      <p
        className={`text-xs uppercase tracking-[0.25em] ${
          dark ? "text-zinc-400" : "text-zinc-500"
        }`}
      >
        {label}
      </p>
      {sublabel && (
        <p className={`text-xs ${dark ? "text-zinc-500" : "text-zinc-400"}`}>{sublabel}</p>
      )}
    </div>
  );
}
